import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { MediaBreakPointUp, Colors } from '@lean-body/components/styles';
import { useNavigate } from 'react-router-dom';
import { routes } from '@lean-body/src/route';
import { ArrowDirection, ArrowIconWithMargin } from '../atoms';
export const CourseHeader = ({ volume, classObject, profile }) => {
    const navigate = useNavigate();
    const onClickBack = () => {
        navigate(routes.DAILY_START.compile());
    };
    return (React.createElement("div", { className: css(styles.container, classObject) }, volume ? (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css(styles.nameSmall) },
            profile.userName,
            "\u3055\u3093\u5C02\u7528\u306EAI\u30C7\u30A4\u30EA\u30FC\u30EC\u30C3\u30B9\u30F3",
            React.createElement("br", null),
            "vol. ",
            volume.volumeNumber),
        React.createElement("div", { className: css(styles.lengthInfo) },
            volume.totalLessons,
            "Lessons"),
        React.createElement(ArrowIconWithMargin, { onClick: onClickBack, direction: ArrowDirection.left, classObject: styles.button, color: Colors.Black }))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css(styles.name) },
            profile.userName,
            "\u3055\u3093\u5C02\u7528\u306E",
            React.createElement("br", null),
            "AI\u30C7\u30A4\u30EA\u30FC\u30EC\u30C3\u30B9\u30F3"),
        React.createElement("div", { className: css(styles.desc) }, "\u3042\u306A\u305F\u306B\u3074\u3063\u305F\u308A\u306E\u30EC\u30C3\u30B9\u30F3\u3092\u3001AI\u304C\u9078\u3093\u3067\u304A\u5C4A\u3051\u3057\u307E\u3059\u3002\u30B3\u30C4\u30B3\u30C4\u7D9A\u3051\u3066\u3001\u7FD2\u6163\u306B\uFF01")))));
};
const styles = StyleSheet.create({
    container: {
        background: Colors.BackgroundAi,
        height: 173,
        padding: '28px 20px',
        [MediaBreakPointUp.MD]: {
            padding: '28px 60px',
        },
        [MediaBreakPointUp.XL]: {
            padding: '38px 200px',
        },
    },
    name: {
        fontSize: 24,
        fontWeight: 'bold',
        letterSpacing: '0.96px',
        marginBottom: 10,
    },
    nameSmall: {
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: '160%',
        letterSpacing: '1.28px',
        marginBottom: 10,
    },
    desc: {
        fontSize: 12,
        lineHeight: '160%',
    },
    lengthInfo: {
        fontWeight: 500,
        fontSize: 12,
        lineHeight: '100%',
        color: Colors.Black,
        whiteSpace: 'pre-wrap',
    },
    button: {
        marginTop: 10,
        background: Colors.White,
        borderRadius: 100,
        width: 32,
        height: 32,
        padding: 6,
    },
});
